import { parseDesconto } from "./descontoAgendamento";

function formatarDataEnvio(data) {
  if (!data) return null;
  if (!(data instanceof Date) || Number.isNaN(data.getTime())) return data;

  const ano = data.getFullYear();
  const mes = String(data.getMonth() + 1).padStart(2, "0");
  const dia = String(data.getDate()).padStart(2, "0");
  return `${ano}-${mes}-${dia}`;
}

function validarPayload(payload) {
  if (!payload.cliente.nome && !payload.cliente.cpf) {
    return "Selecione um cliente para gerar o documento.";
  }

  if (!payload.procedimentos.length) {
    return "Selecione ao menos um procedimento.";
  }

  return null;
}

export function montarPayloadPdfAgendamento({
  tipoDocumento = "orcamento",
  cliente,
  observacaoCliente = "",
  enfermeiroId,
  data,
  hora,
  situacao,
  endereco,
  numeroEndereco,
  cep,
  bairro,
  cidade,
  estado,
  complemento,
  observacao,
  desconto,
  formaPagamento,
  localAtendimento,
  pagamentoStatus,
  procedimentoSelecionado,
}) {
  const payload = {
    tipoDocumento,
    observacaoCliente: observacaoCliente.trim(),
    cliente: {
      nome: cliente?.nome || "",
      cpf: cliente?.cpf || "",
      celular: cliente?.celular || "",
    },
    agendamento: {
      data: formatarDataEnvio(data),
      hora: hora || null,
      situacao: situacao || (tipoDocumento === "orcamento" ? "Orçamento" : null),
      endereco,
      enderecoNumero: numeroEndereco,
      cep,
      bairro,
      cidade,
      estado,
      complemento,
      observacoes: observacao,
      desconto: parseDesconto(desconto),
      formaPagamento,
      localAtendimento,
      pagamentoStatus,
      enfermeiroId: enfermeiroId || null,
    },
    procedimentos: procedimentoSelecionado.map(item => ({
      procedimentoId: item.procedimentoId,
      quantidade: item.quantidade ?? 1,
      precoAplicado: item.precoExame ?? item.precoAplicado ?? 0,
    })),
  };

  const erro = validarPayload(payload);
  if (erro) return { payload: null, erro };

  return { payload, erro: null };
}
